import React from 'react';
import { connect } from 'react-redux';

const messages = {
  OUT_OF_DATE: 'Dữ liệu của bạn đã out of date, vui lòng Refresh ( nhấn phím F5) để lấy dữ liệu mới nhất.',
  INVALID_POLICY_NUMBER: 'Số hợp đồng không hợp lệ',
  default: 'Không thể thực hiện yêu cầu',
};

const Component = ({ message, clearMessage, errors }) => {
  if (!message) return null;

  const renderErrors = () =>
    (errors || []).length > 0 ? (
      <ul className='message-list'>
        {errors
          ?.map(e => e.message)
          ?.map(m => (
            <li className='text-white' key={m}>{messages?.[m] || m}</li>
          ))}
      </ul>
    ) : null;

  const renderMessage = () =>
    message ? <span className='text-white'>{messages?.[message] || messages['default']}</span> : null;

  return (
    <div className='position-fixed bg-dark w-100' style={{ zIndex: '2000' }}>
      <div className='container my-3'>
        <div className='row'>
          <div className='col-md-12'>
            {renderMessage()}
            {renderErrors()}
          </div>
          <div className='col-md-12 mt-2'>
            <button type='button' className='btn btn-primary text-white px-3' onClick={clearMessage}>
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    message: state?.app?.message,
    errors: state?.app?.errors || []
  };
};

const mapDispatchToProps = dispatch => {
  return {
    clearMessage: () => dispatch({ type: 'CLEAR_MESSAGE' })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
